import TableDataSource from './TableDataSource';

export class SkuDataError extends Error {};

/**
 * The SKU data class assumes the existence of an SKU column in a
 */
export default class SkuData {

    index: Map<string, number> = new Map();
    data: TableDataSource;

    constructor(data: TableDataSource) {
        this.data = data;
        this.buildIndex();
    }

    buildIndex() {
        const sku = this.data.column('sku');
        for(let i=0; i < sku.length; i++) {
            if(this.index.has(sku[i])) {
                throw new SkuDataError(`SkuData.buildIndex() found duplicate SKU "${sku[i]}"`);
            }
            this.index.set(sku[i], i);
        }
    }

    fields(sku: string): Record<string, string> | undefined {
        const i = this.index.get(sku);
        if(i == null) return;
        return this.data.row(i);
    }

    string(sku: string, field: string): string | undefined {
        const i = this.index.get(sku);
        if(i == null) return;
        return this.data.cell(field, i);
    }

    json(sku: string, field: string): any | undefined {
        const result = this.string(sku, field);
        if(result == null) return;
        return JSON.parse(result);
    }

    boolean(sku: string, field: string): boolean | undefined {
        const result = this.string(sku, field);
        if(result == null) return;
        return Boolean(result);
    }

    number(sku: string, field: string): number | undefined {
        const result = this.string(sku, field);
        if(result == null) return;

        const num = Number(result);

        if(Number.isNaN(num)) return;
        
        return num;
    }

}
